export enum Boutique {
    '普通',
    '精品'
}
export enum ShortRent {
    '不短租',
    '短租'
}
